module.exports = __webpack_public_path__ + "static/caseheader-6d4df2d630b02272359a0ab4ca20ed7e.jpg";